export default __webpack_public_path__ + "static/media/arrow_right_modal.7b2f7f48.svg";